import httpClient from '../../httpClient';

export const getPaymentDiscrepancyLogs = (pageNumber: number, limit: number) => {
  return httpClient({
    method: 'GET',
    url: '/super-admin/payment-discrepancy-logs',
    params: {
      pageNumber: pageNumber + 1,
      limit,
    },
  });
};

export const getPaymentDiscrepancyLogStats = () => {
  return httpClient({
    method: 'GET',
    url: '/super-admin/payment-discrepancy-logs/stats',
  });
};

export const getPaymentDiscrepancyLog = (id: string | number | undefined) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/payment-discrepancy-logs/${id}`,
  });
};
